<template>
  <header class="app-header navbar" v-if="accountId != 73">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>    
    <!-- <router-link v-if="getAccountLogo" class="navbar-brand" to="/dashboard" style="width: 250px!important" >
      <img width="100%" height="100%"  :src="accountLogo" class="align-items-center custom-logo">
    </router-link> -->
    <span style="width: 150px!important" v-html="svg.logo" class="navbar-brand"></span>
    <!-- <router-link v-else class="navbar-brand" to="/dashboard" style="width: 250px!important" v-html="(accountId == 40) ? svg.wpLogo : svg.logo"></router-link> -->
    <b-navbar-nav justified class="header-main">
      <template v-for="(item, index) in headerItems">
        <NavItem :name="item.name" :url="item.url"  :svgIcon="item.svgIcon" :key="index" />
      </template>
    </b-navbar-nav>
    <b-navbar-nav class="right-menu">
      <div v-if="trialUser">
        <i class="fa fa-2x fa-info-circle trial-user mr-5" v-b-tooltip.hover :title="$t('HEADER.TRIAL_USER', { 'END_DATE': endDate })"></i>
      </div>
      <HeaderDropdownAccnt/>
    </b-navbar-nav>
  </header>
  <div class="app-header navbar p-1" style="background: #fbfbfb;" v-else>
    <b-row  style="width: 100%">
      <b-col sm="2" class="text-center">
        <router-link to="/medical_insurance_cards/demo" v-html="svg.logo"></router-link>
      </b-col>
      <b-col sm="8" class="text-center">
        <h3 style="color: #4d4f52; font-weight: bolder; padding-top: 10px;">
          Medical Insurance Cards Processing using Document AI
        </h3>
      </b-col>
      <b-col sm="2">
        <b-navbar-nav style="flex-direction: column; padding-top: 10px;">
          <MicpHeaderAccount />
        </b-navbar-nav>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import MicpHeaderAccount from '../../views/micp/micpHeaderAccount'
import HeaderDropdownAccnt from './HeaderDropdownAccnt.vue'
import NavItem from './NavItem.vue'
import svg from '../../_svg.js'
import { mapGetters } from 'vuex'

export default {
  name: 'c-header',
  props: {
    navItems: Array
  },
  components: {
    MicpHeaderAccount,
    HeaderDropdownAccnt,
    NavItem
  },
  created () {
    if (this.isAgent) {
      this.headerItems = this.navItems.filter(item => item.name === 'FORMS')
    } else {
      this.headerItems = this.navItems
    }
  },
  computed: {
    ...mapGetters(['trialUser', 'endDate', 'accountId', 'accountLogo', 'isAdmin', 'isAgent']),
    getAccountLogo () {
      if (this.accountLogo === 'null' || this.accountLogo === null) {
        return false
      } else {
        return true
      }
    }
  },
  data () {
    return {
      svg: svg,
      headerItems: []
    }
  },
  methods: {
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      this.$emit('showNavBar')
    }
  }
}
</script>

<style lang="scss">
.trial-user {
  color: gray;
}
.app-header.navbar .navbar-brand svg {
  width: 221px;

}
.app-header.navbar {
  padding-left: 0;
}
.header-fixed::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 0px;
}
.custom-logo{
  object-fit: fit;
}
@-moz-document url-prefix() { /* Disable scrollbar Firefox */
  html{
    scrollbar-width: none;
    }
      }
  body {
    margin: 0; /* remove default margin */
    scrollbar-width: none; /* Also needed to disable scrollbar Firefox */
    -ms-overflow-style: none;  /* Disable scrollbar IE 10+ */
    overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Header/Header.vue